import { createClient } from '@supabase/supabase-js';

const supabaseUrl =
  process.env.NEXT_PUBLIC_SUPABASE_URL ||
  process.env.REACT_APP_SUPABASE_URL ||
  '';

const supabaseAnonKey =
  process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  '';

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.warn('Supabase credentials are missing. Did you set them in .env.local?');
}

export const SUPABASE_URL = supabaseUrl;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
  },
});

export const SUPABASE_STORAGE_URL = 'https://gziftifjkmyqvjndwfog.storage.supabase.co/storage/v1/s3';

export const serverlessFunctionsBase =
  'https://mcp.supabase.com/mcp?project_ref=gziftifjkmyqvjndwfog';
